import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import {
  UserPresentation,
  USER_PRESENTATION_AVATAR_SIZES,
} from '@hivebrite/design-system/UserPresentation';

import {
  type Discussion,
  type ConfigUrls,
  type DiscussionCard,
} from 'hb-react/frontoffice/apps/Forum/types';
import { makeSubheaderFromDates } from 'hb-react/frontoffice/components/CardForum/utils';
import UserSnapshot from 'hb-react/shared/components/UserSnapshot';

import ActionsDropdown from './ActionsDropdown';

interface DiscussionUserAndDropdownProps {
  configUrls: Pick<ConfigUrls, 'discussionUrl' | 'editDiscussionUrl'>;
  discussion: Discussion | DiscussionCard;
}

const DiscussionUserAndDropdown = ({
  discussion,
  configUrls,
}: DiscussionUserAndDropdownProps) => {
  const {
    user: { photo_thumb_url: photoThumbUrl, name, id: userId },
    created_at: createdAt,
    updated_at: updatedAt,
  } = discussion;

  const delayFromPublication = makeSubheaderFromDates({
    createdAt,
    updatedAt,
  });

  const userPath = Routes.user_path(userId);

  return (
    <Wrapper>
      <UserSnapshot userId={userId}>
        <UserPresentation
          avatar={photoThumbUrl}
          size={USER_PRESENTATION_AVATAR_SIZES.SMALL}
          name={name}
          headline={delayFromPublication}
          path={userPath}
        />
      </UserSnapshot>
      {configUrls && (
        <ActionsDropdown configUrls={configUrls} discussion={discussion} />
      )}
    </Wrapper>
  );
};

export default DiscussionUserAndDropdown;

const Wrapper = styled(Box).attrs(() => ({
  justifyContent: 'space-between',
  pb: 3,
  width: '100%',
}))`
  & > *:first-child {
    width: 100%;
  }
`;
